import type { RootState } from '@/store/store'

export const selectAcknowledgedQuotaAllowances = (state: RootState): string[] => state.ocrQuotaUiState.acknowledgedAllowanceSignatures
